import React, { useState } from "react";
import { handlePauseAllVideo, removeStylesFromHtml } from "../../utils";
// import { ReactComponent as ArrowUpIcon } from "../../Icons/arrowUp.svg";
import { ReactComponent as ArrowUpIcon } from "../../Icons/arrowUp.svg";

import { ReactComponent as ArrowDownIcon } from "../../Icons/arrowDown.svg";
import { ReactComponent as RFUIcon } from "../../Icons/rfuIcon.svg";
import { ReactComponent as VerifyIcon } from "../../Icons/verify.svg";
import { ReactComponent as CopyIcon } from "../../Icons/copy.svg";
import { ReactComponent as ShareIcon } from "../../Icons/share.svg";
// import Voting from "../Voting/Voting";
import Button2 from "../../NewComponent/Button2/Button2";
import { useDispatch, useSelector } from "react-redux";
import { requestForUpdate } from "../../API/api";
import { toast } from "react-toastify";
import { bindActionCreators } from "redux";
import { Actions } from "../../Action";
// import ImgCarousal from "../Carousal/carousal";
import ImgCarousal from "../../NewComponent/Carousal/carousal";
import Button from "../../NewComponent/Button/Button";
import { CURRENT_ROLE } from "../../API/url";
import { message } from "antd";
import { ColorLens } from "@mui/icons-material";
import Rating from "../../NewComponent/Rating/Rating";
import { useLocation } from "react-router-dom";
import NewCurationButtons from "../ExpertAnswered/NewCurrationButton";
// import NewCurationButtons from "./NewCurrationButton";
// import { handlePauseAllVideo } from "../../utils";

const contentStyle = {
  border: "1px solid #E0E2E6",
  borderRadius: "16px",
  boxShadow: "0px 4px 16px 0px #1018280F",
  width: '100%'
};
const styles={
  // border: '1.2px solid #E0E2E6',
  borderRadius:'6px',
  height:'24px',
  padding:'1px 8px 1px 8px',
  color:'#fff',
  textAlign:'center',
  background:'linear-gradient(90.39deg, #00D1FF 0.34%, #0075FF 99.7%)',
  fontSize:'13px',
  marginLeft:'5px',
  fontWeight:'300',
  display:'flex',
  alignItems:'center',
  // cursor:`${onClickFunc===undefined?"auto":'pointer'}`
}
export default function Answer({ data, question,tabsearchQuery,  fetchData,
  fetchDataCount }) {
  // console.log(data.attachmentURL,'hi')
  const expertAnsweredState = useSelector((state) => state.answeredQuestions);
  const currentPath = useLocation();
  const [messageApi, contextHolder] = message.useMessage();
  const editorState = useSelector(state => state.editor);
  const randomNumber = Math.random() * 10;
  const dispatch = useDispatch();
  const { advanceFilterModalToggle, getSelectedQuestion, getSelectedAnswer } = bindActionCreators(Actions, dispatch)
  const successfulHelpful = (message) => {
    return (
      <>
        <span style={{ fontSize: "12px" }}>{message}</span>
      </>
    );
  };
  const userState = useSelector((state) => state.user);
  const [permission, setPermission] = useState(userState.roles.find(data => data.roleName === CURRENT_ROLE).permissions.find(item => item.id === 9));
  const searchState = useSelector((state) => state.search);
  const [isAccept, setAccept] = useState(null);
  const [isPlay, setPlay] = useState(false);
  const [isShow, setShow] = useState(false);
  const trimString = (str) => {
    if (str?.length > 350) {
      return str.slice(0, 350) + "...";
    }
    return str;
  };
  const ansStyles = {
    marginTop: "10px",
    fontSize: "15px",
    color: "#5C667B",
    lineHeight: "24px",
    fontWeight: "300",
    wordBreak: 'break-word',overflowWrap: 'break-word',
  };
  const showMoreStyles = {
    fontSize: "15px",
    color: "#5C667B",
    lineHeight: "20px",
    fontWeight: "500",
    background:
      "linear-gradient(90.39deg, #00D1FF 0.34%, #0075FF 99.7%)",
    backgroundClip: "text",
    "-webkit-text-fill-color": "transparent",
    "-moz-text-fill-color": "transparent",
    "-ms-text-fill-color": "transparent",
    "-o-text-fill-color": "transparent",
    cursor: "pointer",
    marginTop: "5px",
  };
  const onClickVote = (key) => {
    setAccept(key);
    let payload = {
      questionUuid: question.questionUuidCopy,
      answerUuid: data.answerUuid,
      status: key === 1 ? "accepted" : "reject",
      questionText: searchState.inputValue,
    };
    if (question.askSource === "expertqa") {
      payload["botQuestionText"] = question.question;
      payload["answerText"] = data.answerCopy;
      payload["pdfId"] = "";
    } else if (question.askSource === "Thread") {
      payload["answerText"] = data.threads.join(",");
      payload["pdfId"] = "";
    } else {
      payload["answerText"] = data.answerCopy;
      payload["pdfId"] = data?.attachments[0]?.name?.split(".")[0];
    }
    searchState.expertData.filter(obj => {
      obj.answers.filter(ans => {
        if (ans.answerUuid === data.answerUuid) {
          if (key !== 1) {
            ans.isReject = true;
            ans.isHelpful = false;
          } else {
            ans.isHelpful = true;
            ans.isReject = false;
          }
        }
      })
      return obj;
    })
    requestForUpdate(payload)
      .then((res) => {
        // console.log(newData);
        if (res !== undefined) {
          toast.success(successfulHelpful(res.data.message), {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
      })
      .catch((err) => { });
  };
  const onClickButton = (key) => {
    // console.log("");
  };
  const onClickShareButton = () => {
    advanceFilterModalToggle({ bool: true, value: "shareQuestion" });
    getSelectedQuestion(question);
  };
  const onClickRFU = () => {
    advanceFilterModalToggle({ bool: true, value: "requestForUpdate" });
    getSelectedAnswer(data);
    getSelectedQuestion(question);
  };
  const stripHtml = (htmlString) => {
    return htmlString
      .replace(/<br\s*\/?>/gi, "\n")
      .replace(/<\/p>/gi, "\n\n")
      .replace(/<\/?[^>]+(>|$)/g, "");
  }
  const success = () => {
    messageApi.info("hl");
  };
  const onClickCopy = (text) => {
    toast.success(successfulHelpful("Text copied!"), {
      position: toast.POSITION.TOP_RIGHT,
    });
    let newString = stripHtml(data.answerText);
    navigator.clipboard.writeText(`${question.question}\n\n${newString}`);

  }
  const onClickPlayPause = () => {
    setPlay(!isPlay);
    // if(isPlay){
    //   document.getElementById(`${question.questionUuid}_${randomNumber}`).pause();
    // }else{
    //   document.getElementById(`${question.questionUuid}_${randomNumber}`).play();
    // }
  }
  // console.log("data",data)

  return (
    <>
      {/* {question.askSource==='expert-QA'&& data.attachments && data.attachments.length > 0 && (
            <>
            <div className="mt-1" style={{textAlign:'right'}}><Button type={'primary'} text={isPlay?'Hide Video':'Show Video'} onClickFunc={onClickPlayPause}/></div>
            {isPlay && <div className="mb-4 mt-3" style={{textAlign:'center'}}>
              <div>
                <video
                 id={`${question.questionUuid}_${randomNumber}`}
                  controls
                  onBlur={()=>handlePauseAllVideo()}
                  style={contentStyle}
                >
                  <source
                    src={`${data.attachments[0].objectUrl}#t=${data.startTime},${data.endTime}`}
                    type="video/mp4"
                  />
                </video>
              </div>
            </div>}
            </>
          )} */}

      {data.attachments?.length > 0 &&
        data.attachments.some(att => att.name.includes('.mp4') || att.name.includes('.mov')) && (
          <>
            <div className="mt-1" style={{ textAlign: 'right' }}>
              <Button
                type="primary"
                text={isPlay ? 'Hide Video' : 'Show Video'}
                onClickFunc={onClickPlayPause}
              />
            </div>
            {isPlay && (
              <div className="mb-4 mt-3" style={{ textAlign: 'center' }}>

                {data.attachments
                  .filter(att => att.name.includes('.mp4') || att.name.includes('.mov'))
                  .map((video, index) => (

                    <video
                      key={index}
                      id={`${question.questionUuid}_${randomNumber}_${index}`}
                      controls
                      onBlur={handlePauseAllVideo}
                      style={contentStyle}
                    >
                      <source src={`${video.objectUrl}`} type="video/mp4" />
                    </video>
                  ))}
              </div>
            )}
          </>
        )}
      {data.attachmentURL && data.attachmentURL.length > 0 && (
        <div className="mb-4 mt-3">
          <div>
            <ImgCarousal data={data.attachmentURL} />
          </div>
        </div>
      )}
      <div
        style={ansStyles}
        dangerouslySetInnerHTML={{
          __html: !isShow
            ? removeStylesFromHtml(
              trimString(
                data.answer === null
                  ? question.contextData
                  : data.answer
              )
            )
            : removeStylesFromHtml(
              data.answer === null
                ? question.contextData
                : data.answer
            ),
        }}
      ></div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginTop: "10px",
        }}
      >
        <div>
          {data.answer !== null
            ? data.answer.length > 350 &&
            !isShow && (
              <div onClick={() => setShow(!isShow)} style={showMoreStyles}>
                Show more&nbsp;
                <ArrowDownIcon />
              </div>
            )
            : question.contextData.length > 350 &&
            !isShow && (
              <div onClick={() => setShow(!isShow)} style={showMoreStyles}>
                Show more&nbsp;
                <ArrowDownIcon />
              </div>
            )}
          {data.answer !== null
            ? data.answer.length > 350 &&
            isShow && (
              <div onClick={() => setShow(!isShow)} style={showMoreStyles}>
                Show less&nbsp;
                <ArrowUpIcon />
              </div>
            )
            : question.contextData.length > 350 &&
            isShow && (
              <div onClick={() => setShow(!isShow)} style={showMoreStyles}>
                Show less&nbsp;
                <ArrowUpIcon />
              </div>
            )}
        </div>
        <div style={{display:"flex"}}>

       
        {userState.geoAttributes.userId === data.expertUuid && data.curationStatus==="pending"&&currentPath.pathname.includes('/expertHome/answered') &&<NewCurationButtons question={question} answer={data} tabsearchQuery={tabsearchQuery}
          fetchData={fetchData}
          fetchDataCount={  fetchDataCount}
        />
   
        }
        {/* <NewCurationButtons question={question} answer={data} /> */}
          {!editorState?.ratingBool && (
            <Button2 onClickFunc={onClickButton}>
              <Rating id={data?.origAnswerUuid ?? data?.answerUuid} />
            </Button2>
          )}
       </div>
      </div>
    </>
  );
}
